import QrCode2Icon from '@mui/icons-material/QrCode2';


const Insight = {
  id: '24',
  title: 'Business Insight',
  type: 'group',
  role:'FACTORY_MANAGER,FACTORY_ADMIN',
    children: [
      // {
      //   id: 'customerinsight',
      //   title: 'Customer Insight',
      //   type: 'item',
      //   url: '/',
      //   bottomMenu:'CUSTOMER-INSIGHT',
      //   icon: QrCode2Icon
      // },
      // {
      //   id: 'productinsight',
      //   title: 'Product Insight',
      //   type: 'item',
      //   url: '/',
      //   bottomMenu:'PRODUCT-INSIGHT',
      //   icon: QrCode2Icon
      // },
      {
        id: 'orderinsight',
        title: 'Business Insight',
        type: 'item',
        url: '/',
        bottomMenu:'ORDER-INSIGHT',
        icon: QrCode2Icon
      },
      
    ]
};

export default Insight;